import { Backdrop, Button, Checkbox, Chip, FormControlLabel, Grid, IconButton, Switch, Typography } from "@mui/material";
import { useFormik } from 'formik';
import React, { Fragment, useEffect, useState } from "react";
import * as yup from 'yup';
import CustomDataGrid from "../../../../../components/dataTable/customDataGrid";
import CustomTextField from "../../../../../components/utils/input/customTextField";
import Modal from "../../../../../components/utils/modal/modal";
import { useDispatch } from "react-redux";
import DeletePage from "../../../../../components/utils/deleteModal/deletePage";
import axios from "axios";
import { setSnackbar } from "../../../../../components/hooks/snackBar/reducers";
import { Delete, EditNote } from "@mui/icons-material";
import _ from "lodash";
import Loader from "../../../../../components/loader/loader";
import { Helmet } from "react-helmet-async";
import CustomdropDown from "../../../../../components/utils/dropDown/customdropDown";

const SubCategoryModal = ({ onCancel }) => {
  const dispatch = useDispatch()
  const pageOption = [10, 25, 50, 100];
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(pageOption[0]);
  const [pageCount, setPageCount] = useState(0);
  const [search, setSearch] = useState("");
  const [open, setOpen] = useState(false);
  const [data, setData] = useState([])
  const [isEdit, setIsEdit] = useState(false)
  const [openDialog, setOpenDialog] = useState(false)
  const [active, setActive] = useState(false)
  const [activeId, setActiveId] = useState(null)
  const [isLoader, setIsLoader] = useState(false); //loader
  const [mainData, setMainData] = useState([])

const validationSchema = yup.object({
    subcategory: yup.string().required(),
    mainCategory: yup.object().required(),
})

const formik = useFormik({
  initialValues :{
    subcategory: "",
    mainCategory: null,
  },
  validationSchema:validationSchema,
// onSubmit: isEdit ? handleUpdate : handleCreate
onSubmit: (values) => {
  if (isEdit) {
    handleUpdate(values);
  } else {
    handleCreate(values);
  }
}
})
function handleCreate(){
    const subData = {
      subcategory_name: formik.values.subcategory,
      category_id: formik.values.mainCategory.id,
      subcategory_image: null,
      is_active : active
    }
    setIsLoader(true);
    axios.post('/v1/subcategories', subData)
    .then(res=>{
      setOpen(false)
      handleClose();
      getSubCategoryData()
      dispatch(setSnackbar(true, 'success', 'Created Successfully'))
      setIsLoader(false);
    })
    .catch(err=>{
      dispatch(setSnackbar(true, 'error',err.response.data.errors[0].message))
      setIsLoader(false);
    })
  }

  function onEdit(e){
    console.log(e)
    formik.setFieldValue('typeDesign', e.name)
    setActive(e.isActive)
    setIsEdit(true)
    setOpen(true)
    setActiveId(e.id)
  }

  function handleUpdate(){
    setIsLoader(true);
    const subData = {
      subcategory_name: formik.values.subcategory,
      category_id: formik.values.mainCategory.id,
      subcategory_image: null,
      is_active : active
    }
    axios.put(`/v1/subcategories/${activeId}`, subData)
    .then(res=>{
      setOpen(false)
      getSubCategoryData()
      dispatch(setSnackbar(true, 'success', 'Updated Successfully'))
      setIsLoader(false);
    })
    .catch(err=>{
      dispatch(setSnackbar(true, 'error',err.response.data.errors[0].message))
      console.log(err)
      setIsLoader(false);
    })
  console.log('update')
  }
   
   
    const handleClose = () => {
      formik.resetForm();
      onCancel(false); // This will close the modal
    };
    const getCategoryData = () =>{
        setIsLoader(true);
        axios.get(`/v1/categories`)
        .then(res=>{
          setMainData(res.data)
          setIsLoader(false);
        })
        .catch(err=>{
          console.log(err)
          dispatch(setSnackbar(true, 'error', err.response.data.error))
          setIsLoader(false);
        })
      }
      const getSubCategoryData = () =>{
        setIsLoader(true);
        const url = `/v1/subcategories/${rowsPerPage}/${page + 1}`
        const searchUrl = `/v1/subcategories/${rowsPerPage}/${page + 1}/${search}`
        axios.get(search === '' ? url : searchUrl)
        .then(res=>{
          setData(res.data.data)
          setPageCount(res.data.meta.pagination.total)
        })
        .catch(err=>{
          dispatch(setSnackbar(true, 'error', err.response.data.error))
        })
      }
    
    useEffect(()=>{
      getSubCategoryData()
      getCategoryData()
    },[rowsPerPage, page, search])
  return (

<Fragment>
<Modal onClose={handleClose} onSave={formik.handleSubmit} formik={formik} 

>
<Grid container spacing={2}>
            <Grid item xs={12}>
              <CustomTextField id="subcategory" value={formik.values.subcategory} title="Sub Category" multiple={false} placeholder="Enter sub category" onchange={formik.handleChange} errorMsg={ formik.touched.subcategory &&  Boolean(formik.errors.subcategory) } helperText={formik.touched.subcategory && formik.errors.subcategory}/>
            </Grid>
            <Grid item xs={12} >
              <CustomdropDown
                id="mainCategory"
                data={mainData}
                optionLabel={(option) => option.category_name}
                value={formik.values.mainCategory}
                onchange={(e, value) => {
                  formik.setFieldValue("mainCategory", value);
                }}
                optionEqual={(option, value) => option.category_name === value.category_name}
                placeholder="Select Main Category"
                helperText={formik.touched.mainCategory && formik.errors.mainCategory}
                errorMsg={
                  formik.touched.mainCategory && Boolean(formik.errors.mainCategory)
                }
                title="Main Category"
              />
            </Grid>
            <Grid item xs={12} md={4} lg={3} className="flex items-center">
              <FormControlLabel control={<Checkbox checked={active} onChange={()=>setActive(!active)}/>} label="Active" />
            </Grid>
          </Grid>
</Modal>
</Fragment>
  );
};

export default SubCategoryModal;
